import { jsx } from "react/jsx-runtime";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { validateTidalLicense } from "../../base/index.js";
function Summarize(props) {
  return /* @__PURE__ */ jsx(
    SummarizeIcon,
    {
      "data-testid": "Summarize",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Summarize",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Summarize.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Summarize"
};
validateTidalLicense();
export {
  Summarize
};
//# sourceMappingURL=Summarize.js.map
